import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import logoImage from "../assets/Star.Ryhwa.PNG";
import SEO from "../components/SEO";
import "../styles/About.css";

const About = () => {
  return (
    <div className="about-page-wrapper">
      <SEO
        title="About Our Story"
        description="Learn about Star.Ryhwa - Handcrafted K-Pop goods, custom decoden creations, and fanmade collectibles made with passion."
        canonicalUrl="/about"
      />
      <div className="about-container">
        <div className="about-grid">
          {/* Left Column: Logo, Name & Social / Contact Line */}
          <div className="about-profile-col">
            <div className="about-logo-wrapper">
              <img
                src={logoImage}
                alt="Star.Ryhwa Logo"
                className="about-logo-image"
              />
            </div>

            <h1 className="about-name">Star.Ryhwa</h1>

            <div className="about-socials">
              <a
                href="https://www.instagram.com/star.ryhwa?igsh=NTc4MTIwNjQ2YQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="about-icon-link"
                aria-label="Instagram"
                title="Instagram @star.ryhwa"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>

              <a
                href="https://www.tiktok.com/@star.ryhwa?_r=1&_t=ZT-97YHF75VUir"
                target="_blank"
                rel="noopener noreferrer"
                className="about-icon-link"
                aria-label="TikTok"
                title="TikTok @star.ryhwa"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>

              <a
                href="https://www.youtube.com/@Starryhwaaa"
                target="_blank"
                rel="noopener noreferrer"
                className="about-icon-link"
                aria-label="YouTube"
                title="YouTube @Starryhwaaa"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>

              <a
                href="mailto:officialstar.ryhwa@gmail.com"
                className="about-icon-link"
                aria-label="Email"
                title="Email officialstar.ryhwa@gmail.com"
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div>

          {/* Right Column: Text Area divided into 2 paragraphs (Lorem Ipsum) */}
          <div className="about-text-col">
            <p className="about-text-p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>

            <p className="about-text-p">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est laborum. Sed ut perspiciatis
              unde omnis iste natus error sit voluptatem accusantium doloremque
              laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
              veritatis et quasi architecto beatae vitae dicta sunt explicabo.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
